export const RENTAL_DEALS_QUERY_KEY = "rental-deals";
export const RENTAL_DEAL_QUERY_KEY = "rental-deal";
export const RENTAL_DEAL_RATES_QUERY_KEY = "rental-deal-rates";
export const HOME_RENTAL_DEALS_QUERY_KEY = "home-rental-deals";
export const RENTAL_DEALS_COUNT_PER_PAGE = 15;

export const HOME_RENTAL_DEALS_LIMIT = 4;

export const RENTAL_DEAL_LIST_SORT_FIELDS = {
  agreementNumber: "agreementNumber",
  agreementDate: "agreementDate",
  legalEntityName: "legalEntityName",
  agreementStartDate: "agreementStartDate",
  projectName: "projectName",
  unit: "unit",
  currentRate: "currentRate",
  pricePerMonth: "pricePerMonth",
} as const;

export const RENTAL_DEAL_BUSINESS_CHARACTERISTIC_IDS = {
  priceCategory: 1,
  type: 2,
} as const;
